module.exports = __webpack_public_path__ + "img/400(2)f.64a21e10.png";